module.exports = __webpack_public_path__ + "static/media/solar-panel.b0deda74.svg";